import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['permiteRelatorioAnexado', 'periodicidade', 'exigeAnexoEnviarRelatorio', 'permiteAnexarArquivos']

  connect() {
    this.previousValueRelatorioMensalSemanasSeparadas = this.relatorioMensalComSemanasSeparadas().checked;
    this.toogleRelatorioMensalComSemanasSeparadas()
    this.exibeEscondeCampoExigeAnexo()
  }

  toogleRelatorioMensalComSemanasSeparadas() {
    const periodicidade = this.periodicidadeTarget?.value;
    const permiteRelatorioAnexado = Boolean(this.permiteRelatorioAnexadoTarget?.checked);

    const containerElemento = document.getElementById('relatorio_mensal_fisico_com_semanas_separadas_elemento');
    if (!containerElemento) {
      console.error('Elemento relatorio_relatorio_mensal_fisico_com_semanas_separadas não encontrado!');
      return;
    }

    if (periodicidade == 'mensal' && permiteRelatorioAnexado) {
      containerElemento.style.display = '';
      const elemento = this.relatorioMensalComSemanasSeparadas();
      elemento.checked = this.previousValueRelatorioMensalSemanasSeparadas;
    } else {
      containerElemento.style.display = 'none';
      const elemento = this.relatorioMensalComSemanasSeparadas();
      this.previousValueRelatorioMensalSemanasSeparadas = elemento.checked;
      elemento.checked = false;
    }
  }

  exibeEscondeCampoExigeAnexo() {
    const elemento = document.getElementById('exige_anexo_enviar_relatorios');

    if (this.permiteAnexarArquivosTarget?.checked) {
      elemento.style.display = '';
    } else {
      this.exigeAnexoEnviarRelatorioTarget.checked = false;
      elemento.style.display = 'none';
    }
  }

  relatorioMensalComSemanasSeparadas() {
    const elemento = document.getElementById('relatorio_relatorio_mensal_fisico_com_semanas_separadas');
    return elemento;
  }
}